import axios from "axios";
import { careersInquiryAction } from "./hfdicareersinquiryAction";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

const getAdminURL = (state) => {
  return state.environnment.environmentLists.adminBaseURL;
};

export const getAllCareersInquiryAsync = (searchBy, searchText, type) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      let { skip, limit } = getState().careersInquiry;
      dispatch(careersInquiryAction.getAllCareersInquiryStart());
      const { data } = await axios({
        method: "Get",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/hfdicareers/getAllCareersInquiry?skip=${skip}&limit=${limit}&column=${searchBy}&type=${type}&dir=&search=${searchText}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(
          careersInquiryAction.getAllCareersInquirySuccess(data.data)
        );
      }
      dispatch(careersInquiryAction.getAllCareersInquiryError());
      return dispatch(showSuccessSnackbar("success", data.message, 3000));
    } catch (error) {
      console.log(error);
      dispatch(careersInquiryAction.getAllCareersInquiryError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const getCareersInquiryAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(careersInquiryAction.getCareersInquiryStart());
      const { data } = await axios({
        method: "Get",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/hfdicareers/getCareersInquiry/${id}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(
          careersInquiryAction.getCareersInquirySuccess(data.data)
        );
      }
      dispatch(careersInquiryAction.getCareersInquiryError());
      return dispatch(showSuccessSnackbar("success", data.message, 3000));
    } catch (error) {
      console.log(error);
      dispatch(careersInquiryAction.getCareersInquiryError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const deleteCareersAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const dataarra = [id];

      const adminBaseURL = getAdminURL(getState());
      dispatch(careersInquiryAction.getCareersInquiryStart());
      const { data } = await axios({
        method: "post",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/careers/removeMultiCareers/`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          data: dataarra,
        },
      });
      console.log(id);
      if (data.code === 200) {
        return dispatch(
          careersInquiryAction.getCareersInquirySuccess(data.data)
        );
      }
      dispatch(careersInquiryAction.getCareersInquiryError());
      return dispatch(showSuccessSnackbar("success", data.message, 3000));
    } catch (error) {
      console.log(error);
      dispatch(careersInquiryAction.getCareersInquiryError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};
